import { useMemo } from 'react';
import { ICycleChannelCircleStateProps } from './types';
import { useAbilityContext } from '../../../Can/Can';
import { PAGE_TITLE } from '../../../../constants/common';
import { Action } from '../../../../enums/action';
import { CycleChannelCircleState } from './CycleChannelCircleState';
import { CycleThermocoupleCircleState } from './CycleThermocoupleCircleState';

export interface ICycleTableItemStateProps extends ICycleChannelCircleStateProps {
  isChannel: boolean;
}

export const CycleTableItemState = ({ isChannel, ...props }: ICycleTableItemStateProps) => {
  const ability = useAbilityContext();

  const canReadChannels = useMemo(() => {
    return ability.can(Action.Read, PAGE_TITLE.CONTROLLER_CHANNELS);
  }, [ability]);

  if (!canReadChannels) {
    return null;
  }

  if (isChannel) {
    return <CycleChannelCircleState {...props} />;
  }

  return <CycleThermocoupleCircleState {...props} />;
};
